/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * The header that will be set to a mocked response generated by the archetype
 */

// required attributes
const ArchetypeResponseHeaderR = t.interface({
  name: t.string,

  value: t.string
});

// optional attributes
const ArchetypeResponseHeaderO = t.partial({});

export const ArchetypeResponseHeader = t.intersection(
  [ArchetypeResponseHeaderR, ArchetypeResponseHeaderO],
  "ArchetypeResponseHeader"
);

export type ArchetypeResponseHeader = t.TypeOf<typeof ArchetypeResponseHeader>;
